import Rails from "@rails/ujs"
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['totalPoint', 'fee1', 'fee2', 'fee3', 'fee4', 'fee5', 'fee6', 'fee7', 'fee8', 'fee9', 'fee10', 'fee11','fee12','fee13','fee14','fee15','fee16','fee17','form', 'generateButton', 'paymentLink', 'paymentLinkError', 'paymentLinkAmount', 'mismatchWarning', 'billedButton']
  static classes = []
  static values = {
    generateUrl: String
  }

  connect() {
    this.confirmed = false;
    this.calculateTotalPoint()
  }

  changeFeeItem() {
    this.calculateTotalPoint()
  }

  // 請求項目ID（BillItem）。id=11(値引き)のみ合計から減算、それ以外は加算。
  // active_items から除外された項目はターゲットが描画されないため、
  // 実在するターゲットのみ集計する（未描画ターゲットの無条件参照による例外を防ぐ）。
  static FEE_ITEM_IDS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17]
  static DISCOUNT_ITEM_ID = 11

  calculateTotalPoint() {
    let total = 0
    this.constructor.FEE_ITEM_IDS.forEach((id) => {
      if (!this[`hasFee${id}Target`]) return
      const value = parseInt(this[`fee${id}Target`].value) || 0
      total += id === this.constructor.DISCOUNT_ITEM_ID ? -value : value
    })
    this.totalPointTarget.textContent = total
    this.updateMismatchState(total)
  }

  // 保存されている決済リンクの金額。判定材料が無ければ null（＝判定不能・YAS-21 D-4）。
  get paymentLinkAmount() {
    if (!this.hasPaymentLinkAmountTarget) return null
    const raw = this.paymentLinkAmountTarget.dataset.amount
    if (raw === undefined || raw === '') return null
    const parsed = parseInt(raw, 10)
    return Number.isNaN(parsed) ? null : parsed
  }

  // 画面合計と決済リンク金額の乖離を反映する（YAS-21 FR-2）。
  // 決済リンクを使わない画面（credit / conveni / 法人一括請求）ではターゲットが描画されないため、
  // ここで必ず return し、既存ボタンの状態には一切触れないこと（D-12-1・最重要の非回帰点）。
  updateMismatchState(total) {
    const linkAmount = this.paymentLinkAmount
    if (linkAmount === null) return

    if (total === linkAmount) {
      this.hideMismatch()
    } else {
      this.showMismatch(linkAmount, total)
    }
  }

  showMismatch(linkAmount, total) {
    if (this.hasMismatchWarningTarget) {
      // 文言は design.md §4.2.4 の確定文言。コントローラ・タブERBと同時に直すこと（RV-4）
      this.mismatchWarningTarget.textContent =
        `決済リンクの金額（¥${linkAmount.toLocaleString()}）と現在の請求額（¥${total.toLocaleString()}）が` +
        `一致していません。決済リンクを再生成してから請求してください`
      this.mismatchWarningTarget.style.display = 'block'
    }
    if (this.hasBilledButtonTarget) this.billedButtonTarget.disabled = true
  }

  hideMismatch() {
    if (this.hasMismatchWarningTarget) this.mismatchWarningTarget.style.display = 'none'
    if (this.hasBilledButtonTarget) this.billedButtonTarget.disabled = false
  }

  async generatePaymentLink() {
    const amount = parseInt(this.totalPointTarget.textContent) || 0
    if (amount <= 0) {
      this.showPaymentLinkError("合計金額が0円以下のため、リンクを生成できません")
      return
    }

    const button = this.generateButtonTarget
    button.classList.add('is-loading')
    button.disabled = true
    this.hidePaymentLinkError()

    try {
      // フォームをそのまま送る（YAS-21 FR-0）。サーバは bill_detail_item_* から金額を再計算するため、
      // update_payment と同じキーで送る必要がある。amount はサーバ側の検算・ログ用。
      // Content-Type は指定しない（ブラウザが multipart 境界を付ける。手で指定すると Rails がパースできない）。
      const body = new FormData(this.formTarget)
      body.append('amount', amount)
      const response = await fetch(this.generateUrlValue, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: body
      })
      const data = await response.json()

      if (response.ok) {
        this.paymentLinkTarget.value = data.url
        this.hidePaymentLinkError()
        // 再生成で判定材料を更新し、警告状態を作り直す（YAS-21 FR-4）
        if (this.hasPaymentLinkAmountTarget && data.payment_link_amount !== undefined) {
          this.paymentLinkAmountTarget.dataset.amount = data.payment_link_amount
        }
        this.calculateTotalPoint()
      } else {
        this.showPaymentLinkError(data.error || '決済リンクの生成に失敗しました')
      }
    } catch (e) {
      this.showPaymentLinkError('通信エラーが発生しました')
    } finally {
      button.classList.remove('is-loading')
      button.disabled = false
    }
  }

  showPaymentLinkError(message) {
    if (this.hasPaymentLinkErrorTarget) {
      this.paymentLinkErrorTarget.textContent = message
      this.paymentLinkErrorTarget.style.display = 'block'
    }
  }

  hidePaymentLinkError() {
    if (this.hasPaymentLinkErrorTarget) {
      this.paymentLinkErrorTarget.style.display = 'none'
    }
  }

  buttonDisabled(event){
    const el = event.currentTarget;
    el.disabled = true;
    if (el.name == "save_and_billed_button"){
      this.confirmed = true;
      const sab = document.getElementById("save_and_billed");
      sab.disabled = false;
    }
    if (el.name == "save_and_sales_confirmed_button"){
      const sab = document.getElementById("save_and_sales_confirmed");
      sab.disabled = false;
    }
    if (el.name == "save_and_calculate_waiting_button"){
      const sab = document.getElementById("save_and_calculate_waiting");
      sab.disabled = false;
    }
    const payment_link_required = document.getElementById("payment_link_required");
    if (payment_link_required.value == "true"){
      const payment_link = document.getElementById("payment_link");
      if(payment_link.value == "" || payment_link.value == null){
        this.showPaymentLinkError("決済リンクを入力してください")
        this.confirmed = false;
      }else{
        this.hidePaymentLinkError()
        this.confirmed = true;
      }
    }
    if (this.confirmed == true){
      this.formTarget.submit();
    }else{
      el.disabled = false;
    }
  }

  confirmDialog(event){
    const params = event.params;
    const confirmed = confirm(params.confirm);
    if (!confirmed){
      event.preventDefault();
    }else{
      this.confirmed = true;
    }
  }
}
